import React, { PropsWithChildren, ReactNode } from "react";
import { GridPhoenixLayout } from "~components/GridPhoenix/GridPhoenixLayout";
import { ZoneContainer } from "~components/GridPhoenix/ZoneContainer";
import { ZoneColumn } from "~components/GridPhoenix/ZoneColumn";

type GridPhoenixRightyLayoutProps = {
  className?: string;
  topRail?: ReactNode;
  leftRail: ReactNode;
};

export function GridPhoenixLeftyLayout(
  props: PropsWithChildren<GridPhoenixRightyLayoutProps>
) {
  const { topRail, leftRail, children, className } = props;

  return (
    <GridPhoenixLayout className={className}>
      {topRail && (
        <ZoneContainer variant="full">
          <ZoneColumn variant="full">{topRail}</ZoneColumn>
        </ZoneContainer>
      )}

      <ZoneContainer variant="lefty">
        <ZoneColumn variant="left">{leftRail}</ZoneColumn>
        <ZoneColumn variant="right">{children}</ZoneColumn>
      </ZoneContainer>
    </GridPhoenixLayout>
  );
}
